export default function detectedPlatform() {
  let platform;
  if (typeof ZoomHelper !== "undefined") {
    platform = "android";
  } else if (typeof window !== "undefined" && window.nativeBridge?.send) {
    platform = "windows";
  } else if (
    typeof window !== "undefined" &&
    window.chrome?.webview?.postMessage
  ) {
    platform = "windows";
  } else if (
    typeof window !== "undefined" &&
    typeof window.webkit !== "undefined" &&
    window.webkit?.messageHandlers?.callback
  ) {
    platform = "ios";
  } else {
    platform = "web";
  }
  return platform;
}

export function getVersionDetailsIfApplicable() {
  switch (detectedPlatform()) {
    case "android": {
      try {
        const deviceInfoStr = window.ZoomHelper.getDeviceInfo();
        const deviceInfo = JSON.parse(deviceInfoStr);
        let versionDetail = deviceInfo?.app?.version_code;
        versionDetail = versionDetail ? "v" + versionDetail : "";
        return versionDetail;
      } catch (error) {
        console.error("Device info error:", error);
      }
      break;
    }
    default:
      break;
  }
}
